/**
 * Money formatter — Intl-based, locale-aware.
 */
import { useTranslation } from "react-i18next";

export function formatMoney(
  amount: number | string | null | undefined,
  currency = "SAR",
  locale?: string,
): string {
  if (amount == null || amount === "") return "";
  const n = typeof amount === "number" ? amount : parseFloat(String(amount));
  if (!Number.isFinite(n)) return "";

  const loc =
    locale ??
    (typeof document !== "undefined" &&
    document.documentElement.lang === "ar"
      ? "ar-SA"
      : "en-US");

  try {
    return new Intl.NumberFormat(loc, {
      style: "currency",
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(n);
  } catch {
    // Unknown currency — fall back to a plain number + symbol.
    return `${n.toFixed(2)} ${currency}`;
  }
}

export interface MoneyAmountProps {
  amount: number | string | null | undefined;
  currency?: string;
  className?: string;
}

export function MoneyAmount({ amount, currency = "SAR", className }: MoneyAmountProps) {
  const { i18n } = useTranslation();
  const formatted = formatMoney(amount, currency, i18n.language);
  if (!formatted) return <span className="text-text-tertiary">—</span>;
  return (
    <span className={`tabular-nums ${className ?? ""}`} dir="ltr">
      {formatted}
    </span>
  );
}
